import React from 'react';
import {SectionHeader,ActionWithIcon} from "../../core";

export default function SGSectionHeadingsPage() {

    return <div>
<SectionHeader title="Pinboard" action={<ActionWithIcon size="sm" onClick={()=>{}} text="Edit" inverse />} />
    </div>
}